export default __webpack_public_path__ + "src/images/packages/maliba-lodge/d325989c36d44336d171c6cd73631316-1.jpeg";